import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import IconLightBulb from '@/components/svg/profile-lightbulb.svg?inline';
import { ref } from 'vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import MyProjectContractButtonArea from '@/views/my-projects/components/contract/MyProjectContractButtonArea.vue';
import MyProjectsContractDocumentTable from '@/views/my-projects/components/contract/contractDocuments/MyProjectsContractDocumentTable.vue';
import useProjectsContractsActionState from '@/views/my-projects/components/contracts/myProjectsContractsActionState';
import { createContractDocument } from '@/services/ContractService';
import useContract from '@/views/my-projects/composables/useContract';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractDocuments',
  setup(__props) {

const { t } = useI18n();
const { mode } = useProjectsContractsActionState();
mode.value = 'contract-actions';

const isHelpOpen = ref(false);

const {
  contractDetail,
  openContractDocumentId,
  openChatWithContractPartner,
  deleteOpenContractDocument,
} = useContract();

const isCreatingDocument = ref(false);
const createDocument = async () => {
  if (!contractDetail.value || isCreatingDocument.value) return;
  openContractDocumentId.value = '';
  isCreatingDocument.value = true;
  const document = await createContractDocument(contractDetail.value?.contractId, {
    title: t('contracts.contract.contractDocuments.document.new-document-title')
      .toString()
  });
  isCreatingDocument.value = false;
  contractDetail.value.documents.push({ ...document, files: [] });
  openContractDocumentId.value = document.id;
  contractDetail.value.deletable = false;
};

const openChat = () => {
  openChatWithContractPartner();
};

const isDeletingDocument = ref(false);
const deleteDocument = async () => {
  if (!contractDetail.value || isDeletingDocument.value) return;
  isDeletingDocument.value = true;
  await deleteOpenContractDocument();
  isDeletingDocument.value = false;
};

return { __sfc: true,t, mode, isHelpOpen, contractDetail, openContractDocumentId, openChatWithContractPartner, deleteOpenContractDocument, isCreatingDocument, createDocument, openChat, isDeletingDocument, deleteDocument, MyProjectsSectionHeader, BCXHelpTextTriggerIcon, IconLightBulb, BCXInfoCollapsible, MyProjectContractButtonArea, MyProjectsContractDocumentTable }
}

})